import { render, staticRenderFns } from "./NewDefectPopup.vue?vue&type=template&id=7328c93b&scoped=true&"
import script from "./NewDefectPopup.vue?vue&type=script&lang=js&"
export * from "./NewDefectPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewDefectPopup.vue?vue&type=style&index=0&id=7328c93b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328c93b",
  null
  
)

export default component.exports